import { useState, useCallback } from 'react';

type UseImageCompareResult = {
    isComparing: boolean;
    openCompare: () => void;
    closeCompare: () => void;
};

export function useImageCompare(): UseImageCompareResult {
    const [isComparing, setIsComparing] = useState(false);

    const openCompare = useCallback(() => {
        setIsComparing(true);
    }, []);

    const closeCompare = useCallback(() => {
        setIsComparing(false);
    }, []);

    return {
        isComparing,
        openCompare,
        closeCompare
    };
}
